import {auth , provider} from '../firebase/config';

const Login = () => {

	// Sign in with google
	const signin = () => {
		auth.signInWithPopup(provider).catch(alert);
	}
	
	return (
		<div>
            <div className="flex flex-col items-center w-5/6 m-auto border text-center mt-36 mb-24 md:w-1/3">
                <h2 className="m-8 text-3xl font-bold">Admin Panel</h2>
                <p className="p-4">Sign in to the admin panel using your registered Google login</p>
                <button className="p-4 my-8 font-semibold text-black bg-white hover:bg-neutral-200 rounded-sm" onClick={signin}>Sign in with Google</button>
            </div>
		</div>
	);
}

export default Login;
